/* eslint-disable react/prop-types */
import React from 'react';
import YoutubePlayer from '../../../../../../shared/YoutubePlayer';

export const YoutubeVideoDetail = ({ detail }) => (
    <div className="detail-value">
        <YoutubePlayer width={560} height={315} autoPlay={1} videoId={detail.value} />
    </div>
);
